import './watchse3carousel.css';
import watchSE3Slide1 from '../../../assets/apple/iWatch/WatchSE3/WatchSE3_1.png';
import watchSE3Slide2 from '../../../assets/apple/iWatch/WatchSE3/WatchSE3_2.png';
import watchSE3Slide3 from '../../../assets/apple/iWatch/WatchSE3/WatchSE3_3.png';
import appleBlackLogo from '../../../assets/applephone/appleblacklogo.png';

import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const watchSE3Slides = [
  {
    title: 'Watch SE 3',
    image: watchSE3Slide1,
    price: 'Starts at Rs. 25,900',
    emi: 'or No Cost EMI at Rs. 1,273 p.m.',
    cashback: 'Cashback up to Rs. 2000 on Axis & ICICI Credit Cards.',
    productId: 1,
  },
  {
    title: 'Series 11',
    image: watchSE3Slide2,
    price: 'Starts at Rs. 46,900',
    emi: 'or No Cost EMI at Rs. 2,606 p.m.',
    cashback: 'Cashback up to Rs. 2500 on Axis & ICICI Credit Cards.',
    productId: 7,
  },
  {
    title: 'Ultra 3',
    image: watchSE3Slide3,
    price: 'Starts at Rs. 89,900',
    emi: 'or No Cost EMI at Rs. 4,995 p.m.',
    cashback: 'Cashback up to Rs. 3000 on Axis & ICICI Credit Cards.',
    productId: 6,
  },
];

const WatchSE3Carousel = () => {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const pauseAutoplay = () => {
    swiperInstance?.autoplay?.stop();
  };

  const resumeAutoplay = () => {
    swiperInstance?.autoplay?.start();
  };

  const handleViewDetails = (productId) => {
    navigate(
      `/applestore/iphone-products-list/iphone-detail-page/applewatch/${productId}`
    );
  };

  return (
    <Swiper
      modules={[Pagination, Navigation, Autoplay]}
      navigation
      pagination={{ type: 'progressbar', clickable: true }}
      slidesPerView={1}
      spaceBetween={0}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      style={{ padding: '0 0 3% 0', borderRadius: '40px' }}
      onSwiper={(swiper) => setSwiperInstance(swiper)}
    >
      {watchSE3Slides.map((slide, index) => (
        <SwiperSlide key={`watch-se3-slide-${index + 1}`}>
          <section className="watchse3-carousel">
            <div className="watchse3-content">
              <div className="watchse3-title-container">
                <img
                  className="watchse3-apple-logo"
                  src={appleBlackLogo}
                  alt="Apple logo"
                />
                <h1 className="watchse3-title">{slide.title}</h1>
              </div>
              <h2 className="watchse3-subtitle">{slide.price}</h2>
              <p className="watchse3-emi">{slide.emi}</p>

              <div className="watchse3-image-wrapper">
                <img
                  src={slide.image}
                  alt={`Apple Watch SE 3 slide ${index + 1}`}
                  className="watchse3-image"
                />
              </div>

              <button
                className="watchse3-view-details-btn"
                onClick={() => handleViewDetails(slide.productId)}
                onMouseEnter={pauseAutoplay}
                onMouseLeave={resumeAutoplay}
              >
                View Details
              </button>

              <p className="watchse3-terms">
                *Terms and Conditions Apply. <br />
                The EMI amount may differ from person to person. <br />
                EMI offers are subject to changes without prior notice.
              </p>

              <div className="watchse3-offers">
                <p>{slide.cashback}</p>
              </div>
            </div>
          </section>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default WatchSE3Carousel;
